var values = [];

var Filters = {
	
	manual_filter_update:function($this , filter_name,filter_value){
		values[filter_name] = filter_value;
		filtersUpdate('#'+ $this.closest('.filters').data('controls') , values);
	},

	fixedVform:function(vehicles_form){

		var document_top = $(document).scrollTop();
	    var filters_top = $("#products-list-filter").offset().top;
	    var header_height = $('header').innerHeight();
	    var form_height = vehicles_form.innerHeight();
	    if( document_top > (filters_top - header_height) ){
	    	vehicles_form.addClass('fixed');
	    }else{
	    	vehicles_form.removeClass('fixed');
	    }
	}, 

    init:function(){

    	var vehicles_form = $('.vehicles-form-partial');

		Filters.fixedVform(vehicles_form);
		$(document).scroll(function() {
		    Filters.fixedVform(vehicles_form);
		});    

		if($('.filter-group.vehicle').length>0){
			$('.filter-group.vehicle select').change(function(){
                values['vehicle'] = {};
				$('.filter-group.vehicle select').each(function(){
						values['vehicle'][ $(this).attr('name')] = $(this).val();
				});
                if($(this).closest('.filters').length == 0){
                    alert('filters container not set');
                    return false;
                }
                if($(this).attr('name') == 'trim' && $(this).val()!=null && $(this).val().length > 0){
                	filtersUpdate($(this).closest('.category-products.partial'), values);
                	load_partial($('div[data-partial="vehiclesForm.vehiclesForm-partial"]'));
                }
            });
		}		

		
		if($('.v-form-filter-full').length>0){
			$('.v-form-filter-full select').change(function(){
                values['vehicle'] = {};
				$('.v-form-filter-full select').each(function(){
					values['vehicle'][ $(this).attr('name')] = $(this).val();
				});               
                if($(this).attr('name') == 'trim' && $(this).val()!=null && $(this).val().length > 0){
                	filtersUpdate($(this).closest('.category-products.partial'), values);
                	load_partial($('div[data-partial="vehiclesForm.vehiclesForm-partial"]'));
                }
            });
		}		

		$('.filters input[type="checkbox"],.filters input[type="radio"]').change(function(){
			var option_name = $(this).attr('name');

			values[option_name] = [];
			if($(this).is(':checked') && option_name == $(this).attr('name')){
			values[option_name].push($(this).val());
			}
			
			/*
			$(this).closest('.filter-group').find('input[type="checkbox"]').each(function(){

				if($(this).is(':checked') && option_name == $(this).attr('name')){
					
					values[option_name].push($(this).val());

				}

			});
            
            $(this).closest('.filter-group').find('input[type="radio"]').each(function(){
                
                if($(this).is(':checked')){
                
                    values[option_name].push($(this).val());
                
                }

            });*/

            if($(this).closest('.filters').length == 0){
                alert('filters container not set');
                return false;
            }
			filtersUpdate('#'+$(this).closest('.filters').data('controls'), values);
		});
		
		if($('.filter-group.slider').length>0){

            $('.filter-group.slider').each(function(){
				var counter = 0,
                    $this =  $(this),
                    min = $(this).data('min'),
                    max = $(this).data('max'),
                    filter_slider = $this.find('.slider-block').get(0),
                    filter_slider_name = $this.find('.slider-block').data('name');

                noUiSlider.create(filter_slider, {
					start: [ min, max ],
					step: 1,
					connect: true,
					behaviour: 'drag',
					range: {
						min: min,
						max: max
					},
					format: wNumb({
						decimals: 0,
						postfix: '$'
					})
				});
				var paddingMin = $('.slider-value-min span'),
					paddingMax = $('.slider-value-max span'),
                    sliderDelay = null;

				filter_slider.noUiSlider.on('update', function ( slider_values, handle ) {
					if ( handle ) {
						paddingMax.html(slider_values[handle]);
					} else {
						paddingMin.html(slider_values[handle]);
					}	
					counter = counter +1;


                    if(sliderDelay!=null){
                        clearTimeout(sliderDelay);
                        sliderDelay = null;
                    }

					if(counter>2){
						values[filter_slider_name] = slider_values[0].replace('$','')+','+slider_values[1].replace('$','');

                        sliderDelay = setTimeout(function(){
                            filtersUpdate('#'+ $this.closest('.filters').data('controls') , values);
                        },500);
				    }
				});				
			});
		}
    },

    checkbox_search : function(container){

		var values = [];
		
		var content_scrollbar = container+'-content';
		content_scrollbar.replace("#", "");
		
		var el = new SimpleBar( 
			$(content_scrollbar)[0] ,
			{ autoHide: false }
		);
		
		$(container+' .show_all_btn').click(function(){			
			$(this).closest('li').hide();
			$(this).closest('ul').find('li').removeClass('hidden');			
			el.recalculate();
			return false; 
		}); 
		$(container+' input:text').on('input', $.debounce(200, function(){
				var matches = 0;
				var $q = $(this).val().toLowerCase();
				if( $q ===''){
					$(container+' ul li:not(.show_all)').addClass('hidden');
					$(container+' ul li').each(function(){
						if (typeof $(this).data('index') !== "undefined" && $(this).data('index') < 9) {
                            $(this).removeClass('hidden');
                            
						}
					});
					$(container+' ul li.show_all').removeClass('hidden').show();
					el.recalculate();
				}else{

					$(container+' ul li:not(.show_all)').addClass('hidden');
					$(container+' ul li').each(function(){
						if(typeof $(this).data('search') !== "undefined" &&  $(this).data('search').toLowerCase().indexOf($q) >= 0) {
							$(this).removeClass('hidden');
							matches = matches +1;
							el.recalculate();
						}
					});	
					if(matches<9){
						$(container+' .simplebar-scrollbar').removeClass('visible');
					}else{
						$('.simplebar-scrollbar').addClass('visible');
						el.recalculate();
					}					
					
				}
				
			})
		);					   
    }
};
function filtersUpdate(controls, values){
    var filters = [], t = $(controls);
    t.data(values); 
    load_partial( t , function(){

    	if(PCKRY){    		
            PCKRY = $('#galleriesGrid').packery({
                  itemSelector: '.item',
                  gutter: 0
            }); 
        }

        scroll2element(controls);
    });

}
 